import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild,} from "@angular/core";
import {NavbarItem} from "../models/navbar-item";
import {CommonModule} from "@angular/common";

@Component({
  selector: "app-navbar-office-item",
  templateUrl: "./navbar-office-item.component.html",
  styleUrls: ["./navbar-office-item.component.scss"],
  imports: [
    CommonModule
  ]
})
export class NavbarOfficeItemComponent implements AfterViewInit {
  @Input() navbarItem!: NavbarItem;
  @Output() selectedItem = new EventEmitter<NavbarItem>();

  @Input() actions: boolean = false;
  @Input() mobile: boolean = false;

  @ViewChild("itemContainer") itemContainer!: ElementRef;

  constructor(private elementRef: ElementRef) {

  }

  ngAfterViewInit(): void {
    this.itemContainer.nativeElement.addEventListener("wheel", (e: WheelEvent) => {
      e.preventDefault();
      const scrollContainer = this.itemContainer.nativeElement.querySelector('.overflow-x-auto');
      if (scrollContainer) {
        scrollContainer.scrollLeft += e.deltaY;
      }
    });
  }
}
